import { memo, useMemo } from "react";

import { cn } from "@/lib/chillnn/cn";

export type Size = "small" | "medium";

type Props = {
	color: string;
	size: Size;
	sx?: Array<string>;
};

export const ColorPalette = memo(({ color, size, sx }: Props) => {
	const sizeClassNames = useMemo(() => (size === "small" ? "h-[36px] w-[36px]" : "h-[54px] w-[54px]"), [size]);

	return <div className={cn("rounded-full", sizeClassNames, sx)} style={{ background: color }} />;
});
